import { getField, updateField } from 'vuex-map-fields'
import apiAxios from '../../services/apiAxios'
import helpers from '../../mixins/helpers'
import moment from 'moment'

const state = {
  id: 0,
  ventaId: 0,
  proveedorId: 0,
  proveedor: {},
  proveedorNombre: null,
  bancoCuentaId: 0,
  bancoCuenta: {},
  bancoCuentaNombre: null,
  numeroBoleto: 0,
  fechaAcreditacion: moment(new Date()).format('YYYY-MM-DD'),

  montoAcreditado: 0,
  montoIntereses: 0,
  montoGastos: 0,
  montoIvaInscripto: 0,
  montoIvaNoInscripto: 0,
  montoPercepcionIva: 0,
  montoPercepcionGanancias: 0,
  montoPercepcionComercioIndustria: 0,
  percepcionesProvinciales: [],
  montoPercepcionesProvinciales: 0,
  montoOtrosImpuestos: 0,
  observaciones: '',

  montoRetencionesClientes: 0,
  retencionesClientes: [],
}

const mutations = {
  updateField,

  INICIALIZAR(state, ventaId) {
    state.id = 0
    state.ventaId = ventaId
    state.proveedorId = 0
    state.proveedor = null
    state.proveedorNombre = null
    state.bancoCuentaId = 0
    state.bancoCuenta = null
    state.bancoCuentaNombre = null
    state.numeroBoleto = 0
    state.fechaAcreditacion = moment(new Date()).format('YYYY-MM-DD')
    state.montoAcreditado = 0
    state.montoIntereses = 0
    state.montoGastos = 0
    state.montoIvaInscripto = 0
    state.montoIvaNoInscripto = 0
    state.montoPercepcionIva = 0
    state.montoPercepcionGanancias = 0
    state.montoPercepcionComercioIndustria = 0
    state.percepcionesProvinciales = []
    state.montoPercepcionesProvinciales = 0
    state.montoOtrosImpuestos = 0
    state.observaciones = ''

    inicializarDocumentos(state)
  },
  SET_PROVEEDOR(state, proveedor) {
    state.proveedor = proveedor
    if (proveedor) {
      state.proveedorId = proveedor.id ? proveedor.id : 0
      state.proveedorNombre = proveedor.nombre ? proveedor.nombre.trim() : null
    } else {
      state.proveedorId = 0
      state.proveedorNombre = null
    }
  },
  SET_BANCO_CUENTA(state, bancoCuenta) {
    state.bancoCuenta = bancoCuenta
    if (bancoCuenta) {
      state.bancoCuentaId = bancoCuenta.id ? bancoCuenta.id : 0
      state.bancoCuentaNombre = bancoCuenta.nombre ? bancoCuenta.nombre.trim() : null
    } else {
      state.bancoCuentaId = 0
      state.bancoCuentaNombre = null
    }
  },
  SET_PERCEPCIONES(state, percepcionesProvinciales) {
      state.percepcionesProvinciales= percepcionesProvinciales;

      state.montoPercepcionesProvinciales= state.percepcionesProvinciales
          .reduce((importe, percepcion) => importe + parseFloat(percepcion.importe), 0);
  },
  SET_RETENCION_CLIENTE(state, retencionCliente) {
    state.retencionesClientes.push(retencionCliente)

    if (state.retencionesClientes.length != 0) {
      state.montoRetencionesClientes = state.retencionesClientes.reduce((a, b) => a + b.importe, 0)
    } else {
      state.montoRetencionesClientes = 0
    }
  },
  DELETE_RETENCION_CLIENTE(state, retencionCliente) {
    let itemKey = state.retencionesClientes.findIndex((retencion) => retencionCliente == retencion)

    if (itemKey != -1) {
      state.retencionesClientes.splice(itemKey, 1)
    }

    if (state.retencionesClientes.lenght != 0) {
      state.montoRetencionesClientes = state.retencionesClientes.reduce((a, b) => a + b.importe, 0)
    } else {
      state.montoRetencionesClientes = 0
    }
  },
}

function inicializarDocumentos(state) {
  state.montoRetencionesClientes = 0
  state.retencionesClientes = []
}

const getters = {
  getField,
}

const actions = {
  inicializar({ commit }, ventaId) {
    return new Promise((resolve, reject) => {
      try {
        commit('INICIALIZAR', ventaId)
        // Recuperamos los datos de la ventaId

        resolve()
      } catch (error) {
        reject(helpers.methods.getErrorMessage(error))
      }
    })
  },
  save({ state }) {
    return new Promise((resolve, reject) => {
      let ventaNegociacion = {
        proveedorId: parseInt(state.proveedorId),
        bancoCuentaId: parseInt(state.bancoCuentaId),
        numeroBoleto: parseInt(state.numeroBoleto),
        fechaAcreditacion: moment(state.fechaAcreditacion).format('YYYY-MM-DD'),
        montoAcreditado: parseFloat(state.montoAcreditado),
        montoIntereses: parseFloat(state.montoIntereses),
        montoGastos: parseFloat(state.montoGastos),
        montoIvaInscripto: parseFloat(state.montoIvaInscripto),
        montoIvaNoInscripto: parseFloat(state.montoIvaNoInscripto),
        montoPercepcionIva: parseFloat(state.montoPercepcionIva),
        montoPercepcionGanancias: parseFloat(state.montoPercepcionGanancias),
        montoPercepcionComercioIndustria: parseFloat(state.montoPercepcionComercioIndustria),
        percepcionesProvinciales: state.percepcionesProvinciales
          .filter(percepcion => percepcion.importe != 0)
          .map(percepcion => ({
            jurisdiccionIngresosBrutosId: percepcion.jurisdiccionIngresosBrutosId,
            importe: parseFloat(percepcion.importe),
          })),
        montoOtrosImpuestos: parseFloat(state.montoOtrosImpuestos),
        observaciones: state.observaciones.trim(),

        retencionesClientes: state.retencionesClientes,
      }

      apiAxios.post(`ventas/${state.ventaId}/negociaciones/add`, ventaNegociacion)
        .then(() => resolve())
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  setProveedor: ({ commit }, proveedor) => {
    commit('SET_PROVEEDOR', proveedor)
  },
  setBancoCuenta: ({ commit }, bancoCuenta) => {
    commit('SET_BANCO_CUENTA', bancoCuenta)
  },
  setPercepciones: ({commit}, percepciones) => {
    commit('SET_PERCEPCIONES', percepciones);
  },  
  setRetencionCliente({ commit }, retencionCliente) {
    commit('SET_RETENCION_CLIENTE', retencionCliente)
  },
  deleteRetencionCliente({ commit }, retencionCliente) {
    commit('DELETE_RETENCION_CLIENTE', retencionCliente)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
